import logoUrl from '@/assets/loyaltybridge-icon-128.png';

interface BrandLogoProps {
  /** Tailwind size classes, e.g. "w-9 h-9". */
  className?: string;
}

/** The LoyaltyBridge logo mark (transparent PNG). Pair it with the "LoyaltyBridge" text where needed. */
export default function BrandLogo({ className = 'w-9 h-9' }: BrandLogoProps) {
  return <img src={logoUrl} alt="LoyaltyBridge logo" className={`${className} shrink-0 object-contain`} draggable={false} />;
}
